import { Column, GridRow } from '@shared';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { IChangeset } from '@shared-data';
import { v4 as uuidv4 } from 'uuid';
import { IAvailabilityItem } from './availability-item.interface';

class ComboAvailabilityChangeset implements IChangeset, IAvailabilityItem {
  id: string;
  restaurantId: string;
  categoryId?: string;
  status?: string;

  @Column({
    field: 'restaurantName',
    title: 'Restaurant',
    order: 0,
    width: 80,
    sortable: true,
    visibleInDetailsView: false,
    visibleInQuickView: true,
    align: 'left',
  })
  restaurantName?: string;

  @Column({
    field: 'tierName',
    title: 'Tier',
    order: 0,
    width: 150,
    sortable: true,
    visibleInDetailsView: false,
    visibleInQuickView: true,
    align: 'left',
  })
  tierName?: string;

  plu?: string;

  @Column({
    field: 'comboParId',
    title: 'Brink ID',
    order: 2,
    width: 90,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
    hidden: true,
  })
  comboParId?: string;

  @Column({
    field: 'comboName',
    title: 'Product',
    order: 1,
    width: 100,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  comboName: string;

  comboId: string;

  itemDescription?: string;

  @Column({
    field: 'itemPrice',
    title: 'Current Combo Price',
    order: 6,
    type: 'number',
    pipeToken: CurrencyPipe,
    width: 120,
    filterType: 'numeric',
    filterable: true,
    hidden: true,
  })
  itemPrice?: number | undefined;

  @Column({
    field: 'deliveryPrice',
    title: 'Current Delivery Combo Price',
    order: 10,
    type: 'number',
    pipeToken: CurrencyPipe,
    width: 120,
    filterType: 'numeric',
    filterable: true,
    hidden: true,
  })
  deliveryPrice?: number | undefined;

  @Column({
    field: 'entreeName',
    title: 'Entree Name',
    order: 5.9,
    width: 200,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  entreeName?: string;

  entreeId: string;

  @Column({
    field: 'entreeParId',
    title: 'Entree Brink ID',
    order: 2,
    width: 90,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
    visibleInQuickView: false,
  })
  entreeParId: string;

  @Column({
    field: 'isActive',
    title: 'Combo Entree Availability',
    order: 5.95,
    width: 150,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    sortable: true,
    visibleInQuickView: true,
    hidden: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  isActive?: boolean;

  comboActive?: boolean;

  @Column({
    field: 'newAvailability',
    title: 'In Store Combo Entree Availability',
    order: 5.96,
    width: 150,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    editable: true,
    sortable: true,
    visibleInQuickView: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  newAvailability?: boolean;

  @Column({
    field: 'entreePriceAlc',
    title: 'Entree Price ALC',
    order: 6,
    type: 'number',
    pipeToken: CurrencyPipe,
    width: 120,
    filterType: 'numeric',
    filterable: true,
    hidden: true,
  })
  entreePriceAlc?: number;

  @Column({
    field: 'availabilityScheduledDate',
    hidden: true,
    title: 'Availability Change Scheduled Date',
    order: 9,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    editable: true,
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  availabilityScheduledDate: Date | null;

  pricingScheduledDate: Date | null;

  type: string = 'availability';

  //   @Column({
  //   field: 'newDeliveryAvailability1P',
  //   title: 'New 1P Delivery Availability',
  //   order: 13,
  //   type: 'boolean',
  //   editable: true,
  //   width: 90,
  //   filterType: 'boolean',
  //   filterable: true,
  //   visibleInQuickView: true,
  //   filterOptions: [
  //     { name: 'Available', value: true },
  //     { name: 'Not Available', value: false },
  //   ],
  // })
  newDeliveryAvailability1P?: boolean;

  @Column({
    field: 'newDeliveryAvailability3P',
    title: 'App/Delivery Availability',
    order: 13,
    type: 'boolean',
    editable: true,
    width: 90,
    filterType: 'boolean',
    filterable: true,
    visibleInQuickView: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  newDeliveryAvailability3P?: boolean;

  deliveryAvailability1P?: boolean = false;

  deliveryAvailability3P?: boolean = false;

  @Column({
    field: 'lastModAvailInstore',
    hidden: true,
    title: 'Last Modified Availability In-Store',
    order: 14,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  lastModAvailInstore?: Date;

  @Column({
    field: 'lastModAvailDelivery',
    hidden: true,
    title: 'Last Modified Availability Delivery',
    order: 15,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  lastModAvailDelivery?: Date;

  constructor(changeset?: Partial<ComboAvailabilityChangeset>) {
    this.id = uuidv4();
    this.comboName = changeset?.comboName || '';
    this.comboParId = changeset?.comboParId || '';
    this.restaurantId = changeset?.restaurantId || '';
    this.restaurantName = changeset?.restaurantName || '';
    this.itemPrice = changeset?.itemPrice;
    this.comboId = changeset?.comboId || '';
    this.deliveryPrice = changeset?.deliveryPrice;
    this.entreeName = changeset?.entreeName || '';
    this.entreePriceAlc = changeset?.entreePriceAlc;
    this.entreeId = changeset?.entreeId || '';
    this.entreeParId = changeset?.entreeParId || '';
    this.isActive = changeset?.isActive;
    this.restaurantId = changeset?.restaurantId || '';
    this.availabilityScheduledDate =
      changeset?.availabilityScheduledDate || null;
    this.pricingScheduledDate = changeset?.pricingScheduledDate || null;
    this.tierName = changeset?.tierName || '';
    this.comboActive = changeset?.comboActive || false;
    this.newAvailability =
      changeset?.newAvailability !== null
        ? changeset?.newAvailability
        : changeset.isActive;
    this.deliveryAvailability1P = changeset?.deliveryAvailability1P;
    this.deliveryAvailability3P = changeset?.deliveryAvailability3P;
    this.newDeliveryAvailability1P =
      changeset?.newDeliveryAvailability1P !== null
        ? changeset?.newDeliveryAvailability1P
        : this.deliveryAvailability1P;
    this.newDeliveryAvailability3P =
      changeset?.newDeliveryAvailability3P !== null
        ? changeset?.newDeliveryAvailability3P
        : this.deliveryAvailability3P;
    this.status = changeset?.status;
    this.lastModAvailDelivery = changeset?.lastModAvailDelivery;
    this.lastModAvailInstore = changeset?.lastModAvailInstore;
  }
}
export class GridRowComboAvailabilityChangeset extends GridRow(
  ComboAvailabilityChangeset
) {}
